import { Injectable } from '@angular/core';

import { RestService } from "../../../core/services/rest.service";
import { Seguro } from "./seguro.model";
import { apiName } from "./data.service";

@Injectable()
export class SeguroApiService {

  constructor(
    private _restService: RestService
  ) { }

  onPost(object: Seguro, done: any) {
    this._restService.onPost(apiName, object, done);
  }

  onPut(object: Seguro, done: any) {
    this._restService.onPut(apiName, object, done);
  }

  onDelete(objectId: number, done: any) {
    this._restService.onDelete(apiName, objectId, done);
  }

  onGetAll(done: any) {
    var filter: any = {"order":"vencimento","include":["seguradora","bem"]};
    this._restService.onGetPost(apiName, filter, done);
  }

  onGetById(objectId: number, done: any) {
    var filter: any = {"include":["seguradora","bem"]};
    this._restService.onGetPostId(apiName, objectId, filter, done);
  }

  onGetApiUrl() {
    return apiName;
  }

}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/despachos/seguros/shared/seguro-api.service.ts
 **/